var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:_vm.buttonClass,attrs:{"type":_vm.buttonType,"disabled":_vm.isDisabled},on:{"click":function($event){return _vm.$emit('on-click')}}},[_vm._t("default",function(){return [_vm._v("Submit")]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }